module.exports = __webpack_public_path__ + "static/forum-docs-icon-5e93171a686c72ff67b277e910a6f454.svg";